// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"66":"0042a095","218":"72d509f3","389":"fa793d93","500":"0243e8fa","560":"5b86935c","950":"c8cddde5"}[chunkId] + ".css";
};